import {
  initialArticleTilesCollectionFiltersState,
  initialArticleTilesFiltersState,
} from '@/creditflowresearch/application/ArticlesAndStats/Articles/ArticlesTile/constants';
import { ThemeSubtype, ThemeType } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/themeTypes';
import { IMarketArticlesBaseFilterPayload } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/IMarketArticle';
import { buildParentFilters } from '@/creditflowresearch/application/helpers/buildFilters';
import isEmpty from 'lodash/isEmpty';

export const buildCompanyArticlesFilters = (
  companyId: string,
  sponsorName: string,
  issuerName: string,
): Partial<IMarketArticlesBaseFilterPayload> => {
  const parentFilters = buildParentFilters(companyId, sponsorName, issuerName);

  if (isEmpty(parentFilters)) {
    return {};
  }

  return { ...parentFilters, includeEmergingThemes: true };
};

export const getTilePayload = (
    filter: Partial<IMarketArticlesBaseFilterPayload>,
    includedThemeType: ThemeType,
    isConsumerOverview: boolean,
) => ({
  payload: {
    ...initialArticleTilesFiltersState,
    filter,
    tabParams: { includedThemeType, includedThemeSubtype: isConsumerOverview ? ThemeSubtype.abs : null },
  },
  collectionFilters: initialArticleTilesCollectionFiltersState,
});
